import * as moment from 'moment';
import { DateTimeConverter } from 'src/app/core/services/mapper/converters';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Animateur } from '../../commission/models/animateur.model';

export class TourneeAgenda {
    static jsonMap = {
        id: { key: 'id', optional: true },
        terminee: { key: 'terminee', optional: true },
        debut: { key: 'dateDebut', converter: new DateTimeConverter(), optional: true },
        fin: { key: 'dateFin', converter: new DateTimeConverter(), optional: true },
        numero: { key: 'numeroCommission', optional: true, default: '' },
        technicien: { key: 'idTechnicien', converter: new (DataIdConverterFactory.build(Animateur, 'techniciens'))(), optional: true },
        nbOperateurs: { key: 'nbOperateurs', optional: true },
        nbEchantillons: { key: 'nbEchantillons', optional: true }
    };

    id: number;
    terminee: boolean;
    debut: moment.Moment;
    fin: moment.Moment;
    numero: string;
    technicien: Animateur;
    nbOperateurs: number;
    nbEchantillons: number;
}
